import { withPrefix } from "gatsby"
import { isRelativePath } from "./url"
import {
  COUNTY_SCALE,
  DISTRICT_ENGLISH_UNITARY,
  DISTRICT_LONDON,
  DISTRICT_METRO,
  DISTRICT_NON_METRO,
  DISTRICT_SCALE,
  DISTRICT_SCOTTISH_UNITARY,
  POSTAL_TOWN_SCALE,
  REGION_SCALE,
} from "./geographical_scales"

// EXTERNAL

export const HOME_URL = "https://www.caresourcer.com"
export const ABOUT_US_URL = "https://www.caresourcer.com/about-us-2/"
export const COOKIE_POLICY_URL = "https://www.caresourcer.com/cookie-policy/"
export const PRIVACY_POLICY_URL = "https://www.caresourcer.com/privacy-policy/"
export const PROVIDER_LANDING_URL = "https://www.caresourcer.com/providers/"
export const BROWSE_SEARCH_URL = "https://www.caresourcer.com/uk/search/new"
export const BROWSE_SEARCH_PATH = "https://www.caresourcer.com/uk/search"
export const CHOOSE_THE_RIGHT_CARE_HOME_URL =
  "https://www.caresourcer.com/caresupport/arranging-care/choose-right-care-home/"
export const CARE_NEWS_URL = "https://www.caresourcer.com/caresupport/"
export const CARE_MAP_URL = "https://www.caresourcer.com/uk/care-map"
export const CARE_SUPPORT_URL = "https://www.caresourcer.com/caresupport/"

// SOCIAL LINKS

export const FACEBOOK_URL = "https://www.facebook.com/caresourcer/"
export const TWITTER_URL = "https://twitter.com/Caresourcer"
export const LINKEDIN_URL = "https://linkedin.com/company/care-sourcer-limited"

export const generateGeoPathData = (
  geographicScale,
  locationName,
  careType = null,
  districtType = null,
  pageNumber = 1,
) => ({
  geographicScale,
  locationName,
  careType,
  districtType,
  pageNumber,
})

export const slugify = (str) =>
  str
    .toLowerCase()
    // Remove these characters completely
    .replace(/['"]+/g, "")
    // Replace runs of remaining non-alpha characters with a single hyphen
    .replace(/[^a-z]+/g, "-")
    // Remove starting or trailing hyphens
    .replace(/(^-|-$)/g, "")

export const urlifyPath = (path) =>
  isRelativePath(path) ? `${HOME_URL}${withPrefix(path)}` : path

// GEO DIRECTORY

const GEO_SCALE_SUB_PATHS = {
  [POSTAL_TOWN_SCALE]: "towns",
  [DISTRICT_SCALE]: {
    [DISTRICT_LONDON]: "boroughs",
    [DISTRICT_METRO]: "districts",
    [DISTRICT_NON_METRO]: "districts",
    [DISTRICT_ENGLISH_UNITARY]: "unitary-authorities",
    [DISTRICT_SCOTTISH_UNITARY]: "unitary-authorities",
  },
  [COUNTY_SCALE]: "counties",
  [REGION_SCALE]: "regions",
}

export const geoAreaLocationProviderDirectoryPath = (
  geoPathData,
  careServiceType,
) => {
  const {
    geographicScale,
    locationName,
    careType,
    districtType,
    pageNumber,
  } = geoPathData

  let geoAreaSubPath = GEO_SCALE_SUB_PATHS[geographicScale]
  if (geographicScale === DISTRICT_SCALE) {
    geoAreaSubPath = geoAreaSubPath[districtType] || "districts"
  }

  const pageSection = pageNumber > 1 ? `/${pageNumber}` : ""
  const careTypeSection = careType ? `/${slugify(careType)}` : ""
  const careServiceTypeSection = careServiceType
    ? `/${slugify(careServiceType)}`
    : ""
  return `/providers/${geoAreaSubPath}/${slugify(
    locationName,
  )}${careTypeSection}${pageSection}${careServiceTypeSection}/`
}

export const geoAreaLocationProviderDirectoryURL = (
  geoPathData,
  careServiceType,
) =>
  urlifyPath(geoAreaLocationProviderDirectoryPath(geoPathData, careServiceType))

// GEO BREAKDOWN

export const geoBreakdownDirectoryPath = (careType, careServiceType) => {
  const careTypeSection = careType ? `/${slugify(careType)}` : ""
  const careServiceTypeSection = careServiceType
    ? `/${slugify(careServiceType)}`
    : ""

  return `/providers/locations${careTypeSection}${careServiceTypeSection}/`
}

export const geoBreakdownDirectoryURL = (careType, careServiceType) =>
  urlifyPath(geoBreakdownDirectoryPath(careType, careServiceType))

// PROFILES (EXTERNAL: IN MOYO ON WWW.)

export const providerProfileURL = (regulatoryId, regulatoryBody, name) =>
  `https://www.caresourcer.com/uk/providers/${regulatoryBody}/${regulatoryId.toLowerCase()}/${slugify(
    name,
  )}`
